export const filings = state => state.projects.filings.items

// export const projectById = state => id => _.find(projects(state), {id})
// export const projectNameById = state => id => {
//     let project = projectById(state)(parseInt(id))
//     return project ? project.name : '–'
// }
// export const projectsByIds = state => ids => {
//     return _.reduce(ids, (res, id) => {
//         let project = projectById(state)(id)
//         if (project) res.push(project)
//         return res
//     }, [])
// }
// export const currentProjectId = state => state.projects.currentProjectId
// export const currentProject = state => _.find(state.projects.items, {id: state.projects.currentProjectId})
